module.exports = __webpack_public_path__ + "img/extpanelnotischedule.3ba51b4d.svg";